import { BasePage } from '@/components/ui/base-page'

export function OnWheelsPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add OnWheelsPage specific content here */}
    </BasePage>
  )
}